import React from 'react'; 
import ReactDOM  from 'react-dom/client';
import './index.css'; import App from './App';
import { Provider } from 'react-redux';
import configureStore from './helpers/configureStore';
import * as serviceWorker from './serviceWorker';
import 'font-awesome/css/font-awesome.min.css';
import 'examsbook-react-sdk/translations';
const store = configureStore();

 ReactDOM.createRoot(document.getElementById('root')).render(
 <Provider
     store={store}>
         <App /> 
     </Provider>);
    // If you want your app to work offline and load faster, you can change// unregister() to register() below. Note this comes with some pitfalls.// Learn more about service workers: https://bit.ly/CRA-PWAserviceWorker.unregister